import React, { useMemo } from "react";
import { ButtonDropdown } from "@bloomberg/media-ui-dropdown";
import type { DropdownOption } from "@bloomberg/media-ui-dropdown/types";
import styles from "./styles.module.css";
import {
  useUserPreferences,
  useWatchlistActions,
} from "~context/WatchlistContext";

const DASHBOARD_VIEW_OPTIONS = [
  { displayValue: "Overview", value: "DASH" },
  { displayValue: "Comparison Chart", value: "COMP" },
  { displayValue: "Heatmap", value: "HTMP" },
  { displayValue: "Collapsed View", value: "HIDE" },
];

/**
 * Dashboard View Dropdown Component
 *
 * Isolated component that subscribes to userPreferences
 * to prevent unnecessary re-renders of the parent component
 */
export default function DashboardViewDropdown() {
  const userPreferences = useUserPreferences();
  const actions = useWatchlistActions();

  const selectedView = userPreferences?.dashboardView || "DASH";

  const selectedItem = useMemo(
    () =>
      DASHBOARD_VIEW_OPTIONS.find((option) => option.value === selectedView),
    [selectedView]
  );

  const handleSelect = (option?: DropdownOption | null) => {
    if (!option?.value) return;

    void actions.updateUserPreferences({
      dashboardView: option.value as "DASH" | "COMP" | "HTMP" | "STYP" | "HIDE",
    });
  };

  return (
    <div className={styles.dashboardViewDropdownContainer}>
      <ButtonDropdown
        className={styles.dashboardViewDropdown}
        selectedItemOverride={selectedItem}
        onSelect={handleSelect}
        options={DASHBOARD_VIEW_OPTIONS}
      />
    </div>
  );
}
